<template>
  <b-container>
    <br />
    <b-card bg-variant="light">
      <h6>
        Desde aquí puede enviar un mensaje, con archivos adjuntos, en relación a
        este siniestro.
      </h6>
      <hr />
      <p>
        ¿A qué responsable de siniestros quiere dirigir esta comunicación?
        <br /><br /><EmployeeList v-model="destino"></EmployeeList>
      </p>
      <hr />
      <b-form-textarea
        id="textarea"
        v-model="text"
        placeholder="Escriba un mensaje de al menos 10 caracteres..."
        :state="text.length >= 10"
        rows="3"
        max-rows="6"
      ></b-form-textarea>
    </b-card>

    <br />
    <b-card bg-variant="light">
      <h6>Listado de ficheros adjuntos:</h6>
      <hr />
      <b-form-file v-model="selFile" ref="form" placeholder="" />

      <b-button size="sm" variant="outline-primary" @click="submitFile()">
        Adjuntar fichero &nbsp; &nbsp;<i class="fa fa-paperclip"></i
      ></b-button>
      <hr />

      <b-table striped hover :items="sentFiles">
        <template v-slot:cell(opciones)="data">
          <b-button
            size="sm"
            @click="deleteFile(data.item.file_uuid)"
            class="mr-1"
            variant="danger"
          >
            Eliminar
          </b-button>
        </template>
      </b-table>
    </b-card>
    <b-button v-if="!enviado" variant="success" @click="submitMessage()">
      Enviar ahora &nbsp; &nbsp;<i
        class="fa fa-floppy-o"
        aria-hidden="true"
      ></i>
    </b-button>
  </b-container>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import filetypeCellRenderer from "@/_services/api/filetypeCellRenderer.js"; // uploaded file type validator
import { insuranceClaimsService } from "@/_services/api/insuranceClaim.js"; // uploaded file type validator
import { mapState } from "vuex";
import { sizeFormatter, dateFormatter } from "@/_services/api/utils"; // Ag-grid display format for file size and date
import EmployeeList from "@/components/Siniestros/GestionFicheros/EmployeeList.vue";
export default {
  props: ["claim"],
  data() {
    return {
      destino: "",
      remitente: null,
      selFile: null,
      columnDefs: null,
      autoGroupColumnDef: null,
      frameworkComponents: null,
      rowSelection: null,
      gridOptions: {},
      modal: false,
      mShow: false,
      result_id: null,
      status: false,
      selectedDataSizes: [],
      selectedDataTotal: 0,
      text: "",
      sentFiles: [],
      enviado: false,
    };
  },
  components: {
    AgGridVue,
    EmployeeList,
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "Name",
        field: "name",
        width: 300,
        filterParams: { newRowsAction: "keep" },
        checkboxSelection: (params) => {
          return params.columnApi.getRowGroupColumns().length === 0;
        },
        headerCheckboxSelection: function (params) {
          return params.columnApi.getRowGroupColumns().length === 0;
        },
      },
      {
        headerName: "Filetype",
        field: "filetype",
        width: 55,
        cellRenderer: "filetypeCellRenderer",
        filterParams: { newRowsAction: "keep" },
      },
      {
        headerName: "Size",
        field: "size",
        valueFormatter: sizeFormatter,
        width: 55,
        filterParams: { newRowsAction: "keep" },
      },
      {
        headerName: "Added",
        field: "since_added",
        width: 90,
        sort: "desc",
        valueFormatter: dateFormatter,
      },
    ];
    this.frameworkComponents = {
      filetypeCellRenderer: filetypeCellRenderer,
    };
    this.autoGroupColumnDef = {
      headerName: "Group",
      width: 250,
      field: "name",
      valueGetter: (params) => {
        if (params.node.group) {
          return params.node.key;
        } else {
          return params.data[params.colDef.field];
        }
      },
      headerCheckboxSelection: true,
      cellRenderer: "agGroupCellRenderer",
      cellRendererParams: { checkbox: true },
    };
    this.rowSelection = "multiple";
  },
  mounted() {
    //this.$store.dispatch('loadFiles')
    this.gridOApi = this.gridOptions.api;
  },
  computed: {
    ...mapState(["rowData"]),
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      params.api.sizeColumnsToFit();
      params.api.setRowData();
    },
    onRowSelected(event) {
      const selectedNodes = this.gridApi.getSelectedNodes();
      const selectedData = selectedNodes.map((node) => node.data);
      const selectedDataStringPresentation = selectedData
        .map((node) => node.name + " " + node.file_id)
        .join(", ");
      this.selectedDataSizes = selectedData.map((node) => node.size);
      // get the total size
      const add = (a, b) => a + b;
      if (this.selectedDataSizes.length > 0) {
        this.status = true;
        const totalSize = { value: this.selectedDataSizes.reduce(add) };
        this.selectedDataTotal = sizeFormatter(totalSize);
      } else {
        this.status = false;
      }
    },
    async submitFile() {
      if (this.selFile.size < 5 * 1024 * 1024) {
        var vm = this;
        const fd = new FormData();
        fd.append("file", vm.selFile);
        fd.append(
          "description",
          `Siniestro: ${this.claim.claim_id} de ${this.claim.cli_business_name} | Póliza: ${this.claim.policy_company_id} (${this.claim.policy_company_business_name})`
        );
        var newFile = await insuranceClaimsService.submitFile(fd);

        this.sentFiles.push({
          file: newFile.file,
          file_uuid: newFile.file_uuid,
          description: newFile.description,
          timestamp: newFile.timestamp,
          opciones: "",
        });
      } else {
        alert("El archivo es demasiado grande");
      }
    },
    async submitMessage() {
      const fd = new FormData();
      this.remitente = localStorage.getItem("userInfo");
      fd.append("destino", this.destino);
      fd.append("mensaje", this.text);
      fd.append("info", JSON.stringify(this.claim));
      fd.append(
        "asunto",
        `Siniestro: ${this.claim.claim_id} de ${this.claim.cli_business_name} | Póliza: ${this.claim.policy_company_id} (${this.claim.policy_company_business_name})`
      );
      fd.append("remitente", JSON.stringify(this.remitente));
      fd.append("archivos", JSON.stringify(this.sentFiles));
      var newFile = await insuranceClaimsService.submitMail(fd);
      alert("Mensaje enviado");
      this.enviado = true
      this.$root.$emit('bv::hide::modal', 'file-manager', '#btnShow')
      
    },
    async deleteFile(file_uuid) {
      var file = await insuranceClaimsService.deleteFile(file_uuid);
      this.sentFiles = this.sentFiles.filter(function (obj) {
        return obj.file_uuid !== file_uuid;
      });
    },
    handleOk() {
      this.$store.dispatch("deleteFile", this.result_id);
      this.mShow = false;
      this.status = false;
    },
    onRowClicked(event) {
      let file_id = event.node.data.file_id;
      let filename = event.node.data.name;
      this.$store.dispatch("downloadFile", filename);
    },
  },
};
</script>

<style lang="scss">
@import "~ag-grid-community/dist/styles/ag-theme-alpine.css";
.ag-theme-material {
  font-size: 16px !important;
}
.ag-theme-material .ag-row,
.ag-theme-material .ag-row:not(.ag-row-first) {
  padding-top: 7px !important;
}
.ag-cell-focus,
.ag-cell-no-focus {
  border: none !important;
}
.ag-root-wrapper-body.ag-layout-normal {
  border-radius: 4px !important;
}
/* Style buttons */
.btn {
  margin-top: 20px;
  border: none; /* Remove borders */
  color: white; /* White text */
  padding: 12px 16px; /* Some padding */
  font-size: 16px; /* Set a font size */
  cursor: pointer; /* Mouse pointer on hover */
}
/* Darker background on mouse-over */
.btn:hover {
  background-color: Gray;
}
.form-control {
  background-color: #fff !important;
}

.bg-light {
  background-color: #fff !important;
}
</style>
